import { StackView, Icon, Text } from '@planningcenter/tapestry-react';
import React from 'react';
import colors from '../../vendor/topbar/colors.js';

const CustomEmptyStateIndicator = () => (React.createElement(StackView, { alignment: "center", distribution: "center", height: "100%", spacing: 1 },
    React.createElement(Icon, { color: colors.lightNeutral81, name: "general.outlinedTextMessage", size: "64px" }),
    React.createElement(Text, { color: "foregroundTertiary" }, "No conversation")));

export { CustomEmptyStateIndicator };
//# sourceMappingURL=custom_empty_state_indicator.js.map
